module.exports = Rx;


//////////////////
// WEBPACK FOOTER
// external "Rx"
// module id = 193
// module chunks = 0